export default {"src":"/_next/static/media/section7-img.73337caa.svg","height":395,"width":622,"blurWidth":0,"blurHeight":0};